import React from 'react';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const RightArrowIcon = () => (
  <Icon tooltip="Forward" iconObj={faArrowRight} />
);

export default RightArrowIcon;